'use strict';

module.exports = require('./dist/tablefilter/tablefilter').TableFilter;



//////////////////
// WEBPACK FOOTER
// ./~/tablefilter/index.js
// module id = 3906
// module chunks = 0